<ng-container *ngIf="config">
  <nz-form-item *ngIf="config">
    <nz-form-label [nzSpan]="6">默认值</nz-form-label>
    <nz-form-control>
      <input nz-input #nameInput="ngModel" name="value" type="text" [ngModel]="config.value" (ngModelChange)="change($event)" />
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label [nzSpan]="6">字典配置</nz-form-label>
    <nz-form-control nzSpan="24">
      <nz-table nzSize="small">
        <ng-container *ngIf="data.dataSource.length">
          <tr *ngFor="let item of data.dataSource; let i = index">
            <td>
              <input nz-input #nameInput="ngModel" [name]="'label' + i" type="text" [(ngModel)]="item.label" />
            </td>
            <td>
              {{ item.value }}
            </td>
          </tr>
        </ng-container>
      </nz-table>
    </nz-form-control>
  </nz-form-item>
</ng-container>
